import services from "@/http";
import store from "@/store";
import * as storage from "../storage";
import * as types from "./mutation-types";
import { createHash } from "crypto";

import moment from "moment";
import pf_empty from "@/components/Form/PessoaFisica/get_pessoa_fisica_empty";

export const ActionDoLogin = async ({ dispatch }, payload) => {
  let salt = process.env.VUE_APP_ROOT_API + moment().format("Y-MM-DD");
  const hash = createHash("md5");
  const saltResult = hash.update(salt).digest("hex");

  payload.salt = saltResult.toString();

  await services.auth.login(payload).then(async ({ data }) => {
    let user = data.user;

    if (user.roles && user.roles.length) {
      await dispatch("ActionSetUser", user);
      await dispatch("ActionSetToken", {
        token: data.access_token,
        expires_in: data.expires_in,
      });
    }
  });
};

export const ActionCheckToken = async ({ state, dispatch }) => {
  const token = storage.getLocalToken();

  if (!token) {
    return Promise.reject(new Error("Token Inválido"));
  }

  if (!state.token) {
    await dispatch("ActionSetToken", { token: token });
  }

  if (!state.user || !state.user.id) {
    await dispatch("ActionLoadSession");
  }
};

export const ActionLoadSession = async ({ dispatch }) => {
  try {
    const { data } = await services.auth.loadSession().then((res) => {
      return res;
    });
    dispatch("ActionSetUser", data.user);
  } catch (err) {
    dispatch("ActionSignOut");
  }
};

export const ActionSetUser = ({ commit }, user) => {
  if (user.id && !user.pessoa_fisica) {
    user.pessoa_fisica = pf_empty();

    user.pessoa_fisica.contatos.emails[0] = {
      value: user.email,
    };

    user.pessoa_fisica.nome = user.name;
  }

  commit(types.SET_USER, user);
};

export const ActionSetToken = ({ commit }, payload) => {
  if (payload.token && payload.expires_in > 0) {
    let date_expire = moment();
    date_expire.add(payload.expires_in, "seconds");
    storage.setExpiresIn(date_expire.format("YYYY-MM-DD HH:mm"));
  }

  commit(types.SET_TOKEN, payload.token);
  storage.setLocalToken(payload.token);
  storage.setHeaderToken(payload.token);
};

export const ActionSignOut = async ({ dispatch }) => {
  if (store.getters["auth/hasToken"]) {
    try {
      await services.auth.logout();
    } catch (errr) {
      Promise.reject(errr);
    }

    storage.setHeaderToken("");
    storage.deleteLocalToken();
    dispatch("ActionSetUser", {});
    dispatch("ActionSetToken", { token: "" });
    dispatch("ActionSetLogout", true);
  }
};

export const ActionRefresh = async ({ dispatch }) => {
  try {
    const { data } = await services.auth.refresh();
    await dispatch("ActionSetToken", {
      token: data.access_token,
      expires_in: data.expires_in,
    });
  } catch (e) {
    //console.log("E", e);
  }
};

export const ActionEmailVerify = async ({ dispatch }) => {
  try {
    const { data } = await services.auth.verify();
    await dispatch("ActionSetToken", {
      token: data.access_token,
      expires_in: data.expires_in,
    });
  } catch (e) {
    //console.log("E", e);
  }
};

export const ActionForgotPassword = async (store, payload) => {
  try {
    await services.auth.forgotPassword(payload);
  } catch (e) {
    //console.log("E", e);
  }
};

export const ActionResetPassword = async (store, payload) => {
  await services.auth.resetPassword(payload);
};

export const ActionSetLogout = async ({ commit }, payload) => {
  commit(types.SET_LOGOUT, payload);
};

const ActionExpireInMinutes = () => {
  let date_expire = storage.getExpiresIn();
  return moment(date_expire).diff(moment(), "minutes");
};
